module.exports = __webpack_public_path__ + "media/assets/faria_products/FARIA1PLUS-01578bb9392a0a20fd2c0525c764cf6ac7992af921b39fcc3becb8ccf4f8e2d7.png";